import { ReactNode } from 'react';
import { IconCheckDefault, IconPlus } from '@iwoca/icons';
import clsx from 'clsx';
import styles from './CriteriaItem.module.css';

type TProps = {
  children: ReactNode;
  hasPassed?: boolean;
  disabled?: boolean;
  testId?: string;
  className?: string;
};

export const CriteriaItem = ({
  children,
  hasPassed,
  disabled,
  testId,
  className,
}: TProps) => {
  return (
    <div
      className={clsx(styles.container, disabled && styles.disabled, className)}
    >
      {hasPassed || disabled ? (
        <IconCheckDefault
          className={clsx(styles.icon, styles.passIcon)}
          data-testid={`${disabled ? 'disabled' : 'enabled'}-pass-${testId}`}
        />
      ) : (
        <IconPlus
          className={clsx(styles.icon, styles.failIcon)}
          data-testid={`${disabled ? 'disabled' : 'enabled'}-fail-${testId}`}
        />
      )}
      {children}
    </div>
  );
};
